
angular.module("EICDataStream3.domUtilities", [])
  .directive('autoheight', ['$window', function ($window) {
    return function (scope, element, attrs) {
      var margin = parseInt(attrs.margin, 10) || 0;

      var trackScrolling = false;
      if (attrs.trackScrolling)
        trackScrolling = attrs.trackScrolling.toLowerCase() === "true" || false;

      var w = angular.element($window);

      w.resize(function () {
        scope.setElementHeight();
      });

      w.scroll(function () {
        if (trackScrolling) {
          scope.setElementHeight();
        }
      });

      scope.setElementHeight = function () {
        var h = (w.height() - element.offset().top - margin);


        if (trackScrolling)
          h = (w.height() - element[0].getBoundingClientRect().top - margin);
        
        element.height(h + 'px');
      };


      scope.getElementOffsetTop = function () {
        return element.offset().top;
      };

      scope.$watch(scope.getElementOffsetTop, scope.setElementHeight, true);


      w.bind('autoheight',
        function () {
          scope.$apply();
        });

    };
  }
  ])
  .directive('projectSummaryAutoheight', ['$window', '$timeout',
    function ($window, $timeout) {
      return function (scope, element, attrs) {
        var w = angular.element($window);
     
        // Set css propertis that don't have to be redone 
        // on every pass through
        element.css('border-left', 'solid silver 1px');
          
        // bring the scroLLBox class styles into the directive
        // to avoid needing an extra class/styling
        element.css('overflow-y', 'scroll');
        element.css('overflow-x', 'hidden');
        element.css('-webkit-overflow-scrolling', 'touch');
        element.css('margin-bottom', '0px');
        scope.$watch(function () { return w.height(); },
          function (newValue, oldValue) {
            // push the height change to the next turn. 
            // This allows unneeded parts of the UI to 
            // be removed so that the height calulation 
            // returns the correct value
            $timeout(function () {
              element.css('height', (newValue - element.offset().top - 100) + 'px');
            }, 0);
          }, true);

        w.bind('projectSummaryAutoheight',
          function () {
            scope.$apply();
          });

      };
    }
  ]);